import { Link, Typography } from "@mui/material";
import { StyledFlex } from "Components/Shared/StyledComponents";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.SignUp.Form.Fields.AgreeWithTermsAndConditions;

export const MooneLiteEULACheckboxLabel = () => {
  const { t } = useResource();

  return (
    <StyledFlex gap="5px">
      <Typography>
        {t(COMPONENT_RESOURCES.MooneLite.Text)}
        <Link
          target="_blank"
          href={`${getApiUrl()}${t(COMPONENT_RESOURCES.MooneLite.LinkUrl)}`}
          mx={1}
        >
          {t(COMPONENT_RESOURCES.MooneLite.LinkText)}
        </Link>
      </Typography>
    </StyledFlex>
  );
};
